import React from 'react'
import FormatText from '../../FormatText'
import { Okved2 } from '../../../types'

const Okved2ItemSearch: React.FC<{
    item: Okved2
    theme: string
}> = ({ item, theme }) => {
    return (
        <div>
            <div className="flex flex-row w-full justify-start text-center">
                {/* Отступ для вложенности */}
                <div
                    className={`flex flex-row w-full gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#2A282B] hover:bg-[#FFFFFF] dark:hover:bg-[#373538]`}
                >
                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-row w-full items-center justify-center">
                            <div className="flex w-8 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]"></div>
                            <div className="flex w-16 text-left justify-left items-center pl-1">
                                {item.code}
                            </div>
                            <div className="flex flex-row flex-1 items-center justify-left text-left px-2 py-2 gap-2">
                                <div className="flex items-center justify-left text-left">
                                    {item.name}
                                </div>
                            </div>
                        </div>
                        {item.add_info ? (
                            <div className="flex flex-row w-full items-center justify-start ">
                                <div className="flex w-8 text-left justify-left items-center pl-1 "></div>
                                <div className="flex w-16 text-left justify-left items-center pl-1 "></div>
                                <div className="flex flex-1 items-center justify-left text-left pb-2 whitespace-pre-wrap text-[11px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    <FormatText text={item.add_info} />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Okved2ItemSearch
